import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useTypingEffect from "../hooks/useTypingEffect";

interface TypingHeadingProps {
  fullText: string;
  skipOnInternalNavigation?: boolean;
}

const TypingHeading = ({
  fullText,
  skipOnInternalNavigation = true,
}: TypingHeadingProps) => {
  const { t } = useTranslation();
  const { displayedText, showCursor } = useTypingEffect(fullText, {
    skipOnInternalNavigation,
  });

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  // An invisible copy of the full text reserves the final size up front, so
  // the heading (and everything below it) doesn't shift while typing.
  return (
    <span
      className={`page-title`}
      style={{ position: "relative", display: "inline-block" }}
    >
      <span aria-hidden style={{ visibility: "hidden" }}>
        {fullText}
      </span>
      <span style={{ position: "absolute", inset: 0 }}>{displayedText}</span>
    </span>
  );
};

export default TypingHeading;
